import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { ALL_RECIPES } from "../../../../queries/recipesQuery";
import "./LatestRecipes.scss";

const LatestRecipes = () => {
  const { data, loading, error } = useQuery(ALL_RECIPES, {
    variables: { limit: 5 },
  });

  if (loading) return <div></div>;
  if (error) return <div></div>;

  const posts = data?.posts?.nodes || [];

  return (
    <div className="LatestRecipes_container">
      <p className="Latest_recipes_title">Recetat e fundit</p>
      <div className="line"></div>
      {posts.map((item) => (
        <div key={item.slug} className="Recipes_Card">
          <Link to={`/recetat/${item.slug}`} className="link">
            <div className="image-container">
              <img src={item.featuredImage?.node?.sourceUrl} alt="" />
            </div>
            <div className="content-box">
              <p className="recipe_title">{item.title}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default LatestRecipes;
